<template>
  <BaseText
    inline
    :href="helpPageUrl"
    v-test="'website-service-help-page-button'"
  >
    {{ $t('global.learn_more') }}
  </BaseText>
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import { helpCenterArticleUrl } from '@/helpers/help-center';

const helpPageUrl = computed(() => helpCenterArticleUrl(13617949));
</script>
